import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBNXuJn4hpeWyr6JvF0q0se4mOpIV4LL4g",
  authDomain: "chesstreining-3656c.firebaseapp.com",
  projectId: "chesstreining-3656c",
  storageBucket: "chesstreining-3656c.appspot.com",
  messagingSenderId: "111480738294",
  appId: "1:111480738294:web:1b62cfcb34279e290bb7d7",
  measurementId: "G-5QGQ8473CX",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export {
  auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
};
